module.exports = __webpack_public_path__ + "static/SharpSansNo1-Book-8352d73f4434a02a3a909494f3797506.woff2";